import React from "react";
import ErrorBase from "./ErrorBase";

export default function Error404() {
  return (
    <ErrorBase title="Page not found">Error 404: Page not found</ErrorBase>
  );
}
